import * as React from 'react';
import { Shimmer } from 'office-ui-fabric-react';

export const loadingPlaceholderTestId = 'loadingPlaceholderTestId';

export const LoadingPlaceholder = React.memo(() => {
  const shimmerHeight = '15px';

  return (
    <div style={{ padding: '25px 20px 20px 20px' }} data-testid={loadingPlaceholderTestId}>
      <Shimmer height={shimmerHeight} width="140px" style={{ paddingBottom: '20px' }} />
      <Shimmer height={shimmerHeight} width="244px" style={{ paddingBottom: '9px' }} />
      <Shimmer height={shimmerHeight} width="296px" style={{ paddingBottom: '9px' }} />
      <Shimmer height={shimmerHeight} width="187px" />
    </div>
  );
});

// cspell:ignore testid
